<template>
  <v-app>
    <router-view />

    <!-- fab -->
    <v-speed-dial v-if="showFab" v-model="fab" bottom right fixed>
      <template #activator>
        <v-btn v-model="fab" color="accent" dark fab>
          <v-icon v-if="fab">fas fa-times-circle</v-icon>
          <v-icon v-else>fas fa-bars</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark small color="accent" @click="toAbout">
        <v-icon small>fas fa-store</v-icon>
        <div class="fab-text-custom accent">お店</div>
      </v-btn>
      <v-btn fab dark small color="accent" @click="toHistoryList">
        <v-icon small>fas fa-history</v-icon>
        <div class="fab-text-custom accent">注文履歴</div>
      </v-btn>
      <v-btn fab dark small color="accent" @click="toCart">
        <v-icon small>fas fa-shopping-cart</v-icon>
        <div class="fab-text-custom accent">カート</div>
      </v-btn>
      <v-btn fab dark small color="accent" @click="toMenu">
        <v-icon small>fas fa-utensils</v-icon>
        <div class="fab-text-custom accent">メニュー</div>
      </v-btn>
    </v-speed-dial>
  </v-app>
</template>

<script>
import liff from "@line/liff";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ShopRootPage",
  components: {},
  data: () => ({
    // fab
    fab: false,
  }),
  created() {},
  computed: {
    ...mapGetters(["debug", "progress", "showFab","allowPc"]),
  },
  mounted: async function () {
    await liff.ready; // LIFF 初期化待機

    // サービスクローズ中かどうか
    const serviceClosed = await this.isServiceClosed()
    // console.log("serviceClosed", serviceClosed)
    if(serviceClosed) {
      this.hideProgress();
      this.$router.replace({ name: "NotFoundError" });
      return
    }
  },
  methods: {
    ...mapActions(["showProgress", "hideProgress", "isServiceClosed"]),
    ...mapActions("settings", ["loadSettings"]),
    //TODO
    toMenu: function () {
      this.$router.push({ name: "MenuList" });
    },
    toCart: function () {
      this.$router.push({ name: "Cart" });
    },
    toHistoryList: function () {
      this.$router.push({ name: "OrderHistoryList" });
    },
    toAbout: function () {
      this.$router.push({ name: "About" });
    },
  },
};
</script>
<style>
/* .v-speed-dial {
  position: absolute;
} */
.v-btn--floating {
  position: relative;
}
.fab-text-custom {
  position: absolute;
  right: 50px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
}
</style>